import React, { useEffect } from 'react';
import saveConsentToStorage from '../utils/saveConsentToStorage';
import { GOOGLE_CONSENT_LOCAL_STORAGE_ID } from '../constants';
import { opneCloseModal } from '../utils/openCloseModal';
const useGoogleConsent = () => {
    var _a;
    const [consent, setConsent] = React.useState(() => {
        let storedConsent;
        if (typeof window !== 'undefined') {
            storedConsent = localStorage.getItem(GOOGLE_CONSENT_LOCAL_STORAGE_ID);
        }
        return storedConsent ? JSON.parse(storedConsent).consent : false;
    });
    const [dialog, setDialog] = React.useState(null);
    useEffect(() => {
        const dialogEl = document.querySelector('#twoClickDialog');
        if (dialogEl) {
            setDialog(dialogEl);
        }
    });
    let gateway;
    if (typeof window !== 'undefined') {
        gateway = (_a = window === null || window === void 0 ? void 0 : window.Bootstrapper) === null || _a === void 0 ? void 0 : _a.gateway;
    }
    useEffect(() => {
        const handleStorageChange = () => {
            const storedConsent = localStorage.getItem(GOOGLE_CONSENT_LOCAL_STORAGE_ID);
            setConsent(storedConsent ? JSON.parse(storedConsent).consent : false);
        };
        window.addEventListener('storage', handleStorageChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);
    useEffect(() => {
        const syncConsentWithExternalContentCookie = (event) => {
            if (event.detail && event.detail['External Content']) {
                saveConsentToStorage((gateway === null || gateway === void 0 ? void 0 : gateway.getUserPreference('External_Content')) === '1', true);
            }
        };
        document.addEventListener('consent_change', syncConsentWithExternalContentCookie);
        return () => {
            document.removeEventListener('consent_change', syncConsentWithExternalContentCookie);
        };
    });
    useEffect(() => {
        const googleConsentApi = JSON.parse(localStorage.getItem(GOOGLE_CONSENT_LOCAL_STORAGE_ID));
        let consentValue;
        if (googleConsentApi) {
            if (gateway) {
                if (gateway.getUserPreference) {
                    consentValue = gateway.getUserPreference('External_Content') === '1';
                    opneCloseModal(dialog, consentValue);
                }
                else {
                    consentValue = false;
                    opneCloseModal(dialog, consentValue);
                }
            }
            else {
                consentValue = googleConsentApi.consent;
                opneCloseModal(dialog, consentValue);
            }
            googleConsentApi.consent = consentValue;
        }
        else if (!googleConsentApi) {
            if (gateway) {
                if (gateway.getUserPreference) {
                    consentValue = gateway.getUserPreference('External_Content') === '1';
                    opneCloseModal(dialog, consentValue);
                    saveConsentToStorage(consentValue, true);
                }
                else {
                    consentValue = false;
                    opneCloseModal(dialog, consentValue);
                }
            }
            else {
                consentValue = false;
                opneCloseModal(dialog, consentValue);
            }
            const googleConsent = {
                consent: consentValue,
                expiresOn: Date.now() + 180 * 24 * 60 * 60 * 1000,
            };
            localStorage.setItem(GOOGLE_CONSENT_LOCAL_STORAGE_ID, JSON.stringify(googleConsent));
            window.dispatchEvent(new Event('storage'));
        }
    }, [dialog]);
    return consent;
};
export default useGoogleConsent;
